<app-auth-form (submitEvent)="submitHandler($event)"></app-auth-form>
